/* MAIYKO EKLENTI — Şans Çarkı davranışı (v13.1, 29 Eyl 2026)

   v13.1: E-POSTA KAPISI — servise `kapi:true` gider; adres süzgeçten
   geçmezse sunucu 422 döner, KOD ÜRETİLMEZ, yedek yola düşülmez; mesaj
   e-posta alanının altında, öneri varsa kutu açılır, adres düzeltilir.

   v13: e-posta YAZIM HATASI uyarısı (gmal.com → gmail.com mu?) kod
   üretilmeden önce sorulur; sunucu adresi listeye almadıysa kod ekranında
   teslim notu. Ayrıntı: 'YAZIM HATASI UYARISI' bloğu.

   AKIŞ (v11 — TEK DOKUNUŞ, SAYFA DEĞİŞMEZ): tetik (gecikme/scroll) ->
   ÇEVİR (ağırlıklı seçim + animasyon; KOD ÜRETİLMEZ) -> e-posta + segment
   -> 'İNDİRİMİ AL' TEK dokunuş: kupon servisine TEK istek gider; gövdede
   `eposta` ve `etiketler` de vardır, böylece SUNUCU müşteriyi Shopify'da
   abone eder (SUBSCRIBED + etiketler) ve AYNI yanıtta kodu döndürür ->
   ortak kupon durumuna (maiyko_kupon_dyn) 'copied' yazılır, indirim arka
   planda /discount ile sepete işlenir, site geneli koçan AYNI sayfada
   kurulur ve popup 'Kodun hazır ✓' ekranını gösterip kapanır.

   NE KALKTI (v10 -> v11): tarayıcıdaki Shopify native müşteri formu
   gönderimi, Shopify bot korumasının /challenge turu ve "ikinci dokunuş".
   Abonelik artık sunucu tarafında (Admin API) yapılıyor — bkz.
   ~/claude/maiyko-mail/ORTAK-KUPON-SERVISI.md v1.7.

   YEDEK YOL (KORUNDU, SİLİNMEZ): servis isteği düşerse (ağ/zaman
   aşımı/5xx) ESKİ v10 yolu devreye girer — yedek koda düşülür, kayıt
   'active' yazılır, buton "%X KODUN HAZIR ➜" olur ve ziyaretçinin İKİNCİ
   dokunuşu native müşteri formunu gönderir (/challenge turu). Böylece
   abonelik de kupon da tamamen kaybolmaz.

   `abone:false` yanıtı HATA DEĞİLDİR (kupon geçerli): kullanıcıya hiçbir
   şey gösterilmez, yalnız konsola sessiz uyarı düşer.

   KOD NE ZAMAN ÜRETİLİR: YALNIZCA ziyaretçi mail formunu geçerli bir
   e-posta ile gönderdiğinde. Çarkı çevirmek, "kazandın" ekranını görmek ya
   da popup'ı kapatmak TEK BİR KOD BİLE yakmaz; süre de bu yüzden gerçek
   kullanıcı aksiyonuyla başlar.

   GÖSTERME KURALLARI (yalnız OTOMATİK açılış için):
   - localStorage maiyko_cark: {d:'mail'} -> BİR DAHA ASLA;
     {d:'gec', t} -> t + tekrar_gun sonra tekrar.
   - maiyko_kupon_dyn kaydı varsa ve bitis + 24 saat geçmemişse çıkmaz
     (kupon döngüsü sürerken popup araya girmez).
   - Tema editöründe (design_mode) her zaman ve hemen görünür; kayıt yazmaz.

   ELLE AÇMA (v9): kurallar artık init'i KESMEZ, sadece otomatik açılışı
   kapatır — handler'lar her hâlükârda bağlanır ve çark
   window.MaiykoCarkAc() ile açılabilir ('mail' durumunda sessizce hiçbir
   şey yapmaz). Çağıranlar: hatırlatıcı balon ve bilet gövdesi
   (maiyko-kupon-sayac.js).

   HATIRLATICI BALON (v9): ziyaretçi çarkı X/geç ile KAPATTIYSA (durum
   'gec') ve aktif kuponu yoksa, sol altta "🎁 %X HEDİYEN VAR" balonu
   body'ye portallanır — gövdesine dokunmak çarkı geri açar, × oturum
   boyunca (sessionStorage) susturur. */

(function () {
  'use strict';

  var STATE_KEY = 'maiyko_cark';
  var DYN_KEY = 'maiyko_kupon_dyn';
  /* Hatırlatıcı balonun oturumluk susturma bayrağı (sessionStorage). */
  var HATIRLAT_KEY = 'maiyko_cark_hatirlat_gizle';
  var GUN_MS = 24 * 3600 * 1000;

  function oku(key) {
    try {
      var h = window.localStorage.getItem(key);
      return h ? JSON.parse(h) : null;
    } catch (e) {
      return null;
    }
  }

  function yaz(key, deger) {
    try {
      window.localStorage.setItem(key, JSON.stringify(deger));
    } catch (e) {
      /* gizli modda yoksay */
    }
  }

  function init(kok) {
    if (kok.getAttribute('data-mc-kuruldu') === '1') return;
    kok.setAttribute('data-mc-kuruldu', '1');

    /* PORTAL: popup <body>'ye taşınır. position:fixed, transform/filter
       taşıyan bir atanın içinde EKRANA değil o ataya göre çözülür — çark
       yana kayıp kenarlardan kırpılıyor, perde/buğu tüm ekranı
       kaplamıyordu (beden rehberi ve mini kupon ile aynı ders). Tema
       editöründe section yeniden yüklenince taşınmış ESKİ kopya body'de
       kalabilir; yenisi kurulmadan önce eskiler kaldırılır. */
    if (document.body) {
      document.querySelectorAll('[data-maiyko-cark]').forEach(function (eski) {
        if (eski !== kok && eski.parentNode === document.body) {
          try { document.body.removeChild(eski); } catch (e) { /* yoksay */ }
        }
      });
      if (kok.parentNode !== document.body) {
        try { document.body.appendChild(kok); } catch (e2) { /* yoksay */ }
      }
    }

    var design = kok.getAttribute('data-design-mode') === '1';
    var dilimler;
    try {
      dilimler = JSON.parse(kok.getAttribute('data-dilimler'));
    } catch (e) {
      return;
    }
    if (!dilimler || dilimler.length !== 3) return;

    var gecikme = parseInt(kok.getAttribute('data-gecikme'), 10) || 0;
    var scrollYuzde = parseInt(kok.getAttribute('data-scroll'), 10) || 0;
    var tekrarGun = parseInt(kok.getAttribute('data-tekrar-gun'), 10) || 3;
    var mobilGizle = kok.getAttribute('data-mobil-gizle') === '1';
    var servis = (kok.getAttribute('data-servis') || '').replace(/\/$/, '');
    var koleksiyon = kok.getAttribute('data-koleksiyon') || '';
    var yedekKod = kok.getAttribute('data-yedek-kod') || '';
    var yedekYuzde = parseInt(kok.getAttribute('data-yedek-yuzde'), 10) || 10;
    /* v12 KZ (Han Agency): tetik modu, çıkış niyeti, balon anahtarı. Varsayılanlar
       eski davranışı korur: zaman modu, çıkış niyeti kapalı, balon açık. */
    var tetikModu = kok.getAttribute('data-tetik') || 'zaman';
    var cikisNiyeti = kok.getAttribute('data-cikis') === '1';
    var balonAktif = kok.getAttribute('data-balon') !== '0';

    /* TEST KAPISI: URL'de ?cark=test varsa tüm bekleme/görmeme kuralları
       atlanır ve popup 1 sn'de çıkar — akışın geri kalanı GERÇEK (kod
       üretimi, kayıt, sayaç). Yayında zararsız: parametreyi bilen görür. */
    var testMi = /[?&]cark=test\b/.test(window.location.search);

    /* ---- gösterme kararı ----
       v9: kurallar init'i KESMEZ, yalnız OTOMATİK açılışı belirler. Çark
       balondan ya da biletten elle açılabildiği için çevir/mail/kapat
       handler'ları her durumda bağlanmalı. */
    var otoGoster = true;
    if (!design && !testMi) {
      var durum = oku(STATE_KEY);
      var simdi = Date.now();
      var dyn = oku(DYN_KEY);
      if (mobilGizle && window.innerWidth < 600) otoGoster = false;
      else if (durum && durum.d === 'mail') otoGoster = false;
      else if (durum && durum.d === 'gec' && simdi < (durum.t || 0) + tekrarGun * GUN_MS) otoGoster = false;
      else if (dyn && typeof dyn.bitis === 'number' && simdi < dyn.bitis + GUN_MS) otoGoster = false;
    }
    if (testMi) gecikme = 1;

    var donen = kok.querySelector('[data-mc-donen]');
    var asamalar = {
      1: kok.querySelector('[data-mc-asama="1"]'),
      2: kok.querySelector('[data-mc-asama="2"]'),
      3: kok.querySelector('[data-mc-asama="3"]')
    };
    var secilen = null; /* {y, s} */
    var kodDurum = null; /* null=üretiliyor, {kayit}=hazır, {hata}=başarısız */
    /* v11: servis yolu başarıyla bittiğinde true olur — bu andan sonra
       popup'ın kapanışı STATE_KEY'i 'gec' ile EZMEZ ({d:'mail'} kalır). */
    var mailKaydedildi = false;
    var istekYolda = false; /* çift dokunuş kilidi */
    var gosterildi = false;
    var balon = null; /* hatırlatıcı balon düğümü (body'ye portallanır) */

    function asama(n) {
      for (var k in asamalar) {
        if (asamalar[k]) asamalar[k].classList.toggle('is-acik', String(n) === k);
      }
      /* Mail/kod ekranlarında merkez daire büyür — form %61'e sığmıyordu. */
      kok.classList.toggle('maiyko-cark--mail', n >= 2);
    }

    function goster() {
      if (gosterildi) return;
      gosterildi = true;
      kok.hidden = false;
      if (document.body) document.body.style.overflow = 'hidden';
    }

    function gizle() {
      kok.hidden = true;
      if (document.body) document.body.style.overflow = '';
    }

    /* ---- elle açma + hatırlatıcı balon (v9) ---- */

    /* Balon oturum boyunca susturuldu mu (× ile kapatıldıysa). */
    function balonSusturuldu() {
      try {
        return window.sessionStorage.getItem(HATIRLAT_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function balonuKaldir() {
      if (balon && balon.parentNode) {
        try { balon.parentNode.removeChild(balon); } catch (e) { /* yoksay */ }
      }
      balon = null;
    }

    /* Balon YALNIZCA: çark kapatılmışsa (durum 'gec'), aktif kupon yoksa ve
       ziyaretçi balonu bu oturumda × ile susturmamışsa çıkar. */
    function balonKosulu() {
      if (design || testMi) return false;
      var d = oku(STATE_KEY);
      if (!d || d.d !== 'gec') return false;
      var dy = oku(DYN_KEY);
      if (dy && typeof dy.bitis === 'number' && Date.now() < dy.bitis) return false;
      return !balonSusturuldu();
    }

    /* PORTAL: balon da body'ye eklenir (çark ve mini kupon ile aynı ders —
       transform taşıyan bir atanın içinde position:fixed ekrana göre
       çözülmüyor). Rozetteki oran EN YÜKSEK dilimdir: hatırlatma en iyi
       ihtimali gösterir. */
    function balonuKur() {
      if (!balonAktif) return; /* v12 KZ: balon kapatılabilir */
      if (balon || !document.body || !balonKosulu()) return;
      var enYuksek = 0;
      dilimler.forEach(function (dl) {
        var y = parseInt(dl && dl.y, 10);
        if (isFinite(y) && y > enYuksek) enYuksek = y;
      });
      if (!enYuksek) return;

      balon = document.createElement('button');
      balon.type = 'button';
      balon.className = 'maiyko-cark-hatirlat';
      balon.innerHTML =
        '🎁 <b>%' + enYuksek + '</b> <span>HEDİYEN VAR</span>' +
        '<span class="maiyko-cark-hatirlat__kapat" data-mc-hatirlat-kapat>×</span>';

      balon.addEventListener('click', function () {
        balonuKaldir();
        if (window.MaiykoCarkAc) window.MaiykoCarkAc();
      });

      var kapatEl = balon.querySelector('[data-mc-hatirlat-kapat]');
      if (kapatEl) kapatEl.addEventListener('click', function (e) {
        if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
        balonuKaldir();
        try { window.sessionStorage.setItem(HATIRLAT_KEY, '1'); } catch (er) { /* yoksay */ }
      });

      document.body.appendChild(balon);
    }

    /* Site geneli açma kapısı: balon ve bilet buradan çağırır. Kayıt olmuş
       ziyaretçiyi ('mail') ASLA rahatsız etmez; diğer hallerde bekleme
       kuralları geçersizdir (açılış kullanıcının kendi isteğidir), bu yüzden
       goster()'in `gosterildi` bayrağı beklenmeden doğrudan görünür yapılır. */
    window.MaiykoCarkAc = function () {
      var d = oku(STATE_KEY);
      if (d && d.d === 'mail') return;
      balonuKaldir();
      gosterildi = true;
      kok.hidden = false;
      if (document.body) document.body.style.overflow = 'hidden';
    };

    /* ---- tetikleyiciler ---- */
    if (design) {
      goster();
    } else if (otoGoster) {
      /* v12 KZ: kaydırma/çıkış modunda gecikme sayacı YOK — ziyaretçi önce ürünü görür.
         Test kapısı (?cark=test) her modda 1 sn'de açar. */
      if (testMi) window.setTimeout(goster, 1000);
      else if (tetikModu !== 'kaydirma_cikis' && gecikme >= 0) window.setTimeout(goster, gecikme * 1000);
      if (cikisNiyeti) {
        /* Masaüstü: imleç pencerenin üstünden çıkınca (sekme/adres çubuğuna gidiş). */
        document.addEventListener('mouseout', function (e) {
          if (e.relatedTarget || e.toElement) return;
          if (typeof e.clientY === 'number' && e.clientY <= 0) goster();
        });
        /* Mobil: aşağı inmiş kullanıcının hızlı yukarı kaydırma hamlesi (bir kez). */
        var mcSonY = window.scrollY || 0, mcSonT = Date.now(), mcDerin = false, mcYapildi = false;
        window.addEventListener('scroll', function () {
          if (mcYapildi) return;
          var y = window.scrollY || document.documentElement.scrollTop || 0;
          var d = document.documentElement;
          var toplam = d.scrollHeight - d.clientHeight;
          if (toplam > 0 && y / toplam > 0.2) mcDerin = true;
          var simdiT = Date.now();
          if (mcDerin && window.innerWidth < 750 && mcSonY - y > 260 && simdiT - mcSonT < 450) {
            mcYapildi = true;
            goster();
          }
          mcSonY = y; mcSonT = simdiT;
        }, { passive: true });
      }
      if (scrollYuzde > 0) {
        var scrollDinle = function () {
          var d = document.documentElement;
          var toplam = d.scrollHeight - d.clientHeight;
          if (toplam <= 0) return;
          if ((window.scrollY || d.scrollTop) / toplam * 100 >= scrollYuzde) {
            goster();
            window.removeEventListener('scroll', scrollDinle);
          }
        };
        window.addEventListener('scroll', scrollDinle, { passive: true });
      }
    }

    /* Daha önceki bir ziyarette kapatılmışsa balon sayfa kurulumunda çıkar. */
    balonuKur();

    /* ---- kapat / geç ---- */
    function kapatildi() {
      gizle();
      if (design) return;
      /* v11: kod alındıktan sonra kapanış 'mail' bayrağını EZMEZ ve
         hatırlatıcı balonu geri getirmez (ziyaretçi zaten kaydoldu). */
      if (mailKaydedildi) return;
      yaz(STATE_KEY, { d: 'gec', t: Date.now() });
      /* Kapanışın hemen ardından balon: hediye kaybolmadı, geri dönülebilir. */
      balonuKur();
    }

    kok.querySelectorAll('[data-mc-kapat]').forEach(function (b) {
      b.addEventListener('click', kapatildi);
    });
    var ort = kok.querySelector('[data-mc-ort]');
    if (ort) ort.addEventListener('click', kapatildi);

    /* ---- çevir: ağırlıklı seçim + animasyon ---- */
    var cevirBtn = kok.querySelector('[data-mc-cevir]');
    if (cevirBtn) cevirBtn.addEventListener('click', function () {
      if (cevirBtn.disabled) return;
      var toplam = 0;
      dilimler.forEach(function (d) { toplam += Math.max(0, d.a || 0); });
      var hedef = 1; /* ağırlıklar sıfırsa orta dilim */
      if (toplam > 0) {
        var zar = Math.random() * toplam;
        for (var i = 0; i < dilimler.length; i++) {
          zar -= Math.max(0, dilimler[i].a || 0);
          if (zar <= 0) { hedef = i; break; }
        }
      }
      secilen = dilimler[hedef];

      /* Dilim yerleşimi: 0=%1.dilim SOL (240-360), 1=%2 SAĞ (0-120), 2=%3 ALT (120-240).
         SVG'de dilim i açısal [i*120, (i+1)*120) ve data sırası [d1 sol, d2 sağ, d3 alt]
         eşlemesi: d1 -> orta 300°, d2 -> orta 60°, d3 -> orta 180°. */
      var ortaAci = [300, 60, 180][hedef];
      donen.__d = (donen.__d || 0);
      donen.__d += 360 * 5 + (360 - ortaAci) - (donen.__d % 360);
      donen.style.transform = 'rotate(' + donen.__d + 'deg)';
      cevirBtn.disabled = true;

      /* KOD BURADA ÜRETİLMEZ (v10). Çevirmek bir niyet beyanı değil; kod
         ancak ziyaretçi e-postasını verip "bu kodu istiyorum" dediğinde
         (mail formu gönderimi) yakılır. Animasyon ve "kazandın" ekranı
         kodsuz çalışır; üretim mcForm submit handler'ındadır. */

      /* Dönüş 4.2s: durunca kazanan dilim ibrenin altında ~1.1s PARLAR
         (kullanıcı neyi kazandığını çarkta görür), sonra merkez 'Kazandın'
         ekranına geçer. */
      window.setTimeout(function () {
        var dilimEl = kok.querySelector('[data-mc-dilim="' + hedef + '"]');
        if (dilimEl) dilimEl.classList.add('is-kazanan');
        window.setTimeout(function () {
          var oranYazi = '%' + secilen.y + ' indirim';
          var o1 = kok.querySelector('[data-mc-oran]');
          var o2 = kok.querySelector('[data-mc-oran2]');
          if (o1) o1.textContent = oranYazi;
          if (o2) o2.textContent = oranYazi;
          asama(2);
          cevirBtn.disabled = false;
        }, 1100);
      }, 4300);
    });

    /* ---- e-posta + kod üretimi ---- */
    function mailGecerli(m) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(m);
    }

    /* v13.1: hata satırının varsayılan metni (kapı mesajından sonra geri alınır). */
    var hataElIlk = kok.querySelector('[data-mc-hata]');
    var hataMetinVarsayilan = hataElIlk ? hataElIlk.textContent : 'Geçerli bir e-posta adresi gir';
    function hataGoster(metin) {
      var h = kok.querySelector('[data-mc-hata]');
      if (!h) return;
      h.textContent = metin || hataMetinVarsayilan;
      h.hidden = false;
    }

    /* ---- v13 (29 Eyl 2026) — YAZIM HATASI UYARISI ----
       gmal.com, hotmial.com, outlok.com, gmail.coms, gmail.com.tr gibi
       adreslerde kod üretilmeden ÖNCE "gmail.com mu demek istedin?" sorulur.
       Sunucu (epostaSaglik.ts) bu adresleri zaten listeye ALMIYOR (bounce
       %9,3 → Shopify Email otomasyonu duraklatmıştı); buradaki amaç anneye
       düzeltme şansı vermek ki hoş geldin mailini ALABİLSİN.
       Liste ve algoritma sunucuyla aynı: bilinen sağlayıcı → geç; popüler
       sağlayıcıya 1 düzenleme uzaklığı (yer değiştirme dâhil) ya da sonuna
       takılmış fazlalık (gmail.com.tr, gmail.comgamze) → öneri. Öneri kutusu
       ve kod ekranındaki not JS ile kurulur; liquid'e dokunulmaz. */
    var POPULER_ALANLAR = ['gmail.com', 'hotmail.com', 'outlook.com', 'icloud.com', 'yahoo.com', 'yandex.com',
      'hotmail.com.tr', 'live.com', 'yandex.com.tr', 'outlook.com.tr', 'yahoo.com.tr', 'protonmail.com'];
    var BILINEN_ALANLAR = ['googlemail.com', 'hotmail.co.uk', 'hotmail.de', 'hotmail.fr', 'hotmail.it', 'hotmail.es',
      'outlook.de', 'outlook.fr', 'live.com.tr', 'live.de', 'live.fr', 'msn.com', 'windowslive.com', 'me.com', 'mac.com',
      'yahoo.co.uk', 'yahoo.de', 'yahoo.fr', 'ymail.com', 'rocketmail.com', 'yandex.ru', 'mail.ru', 'proton.me', 'pm.me',
      'mail.com', 'gmx.com', 'gmx.de', 'gmx.net', 'aol.com', 'mynet.com', 'superonline.com', 'ttmail.com', 'turk.net',
      'maiyko.com'];

    /* Damerau-Levenshtein (OSA); `ust` aşılınca ust+1 ile erken döner. */
    function duzenlemeUzakligi(a, b, ust) {
      if (a === b) return 0;
      if (Math.abs(a.length - b.length) > ust) return ust + 1;
      var n = a.length, m = b.length, i, j;
      var onceki2 = [], onceki = [], simdiki;
      for (j = 0; j <= m; j++) onceki[j] = j;
      for (i = 1; i <= n; i++) {
        simdiki = [i];
        var satirEnAz = i;
        for (j = 1; j <= m; j++) {
          var maliyet = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
          var deger = Math.min(onceki[j] + 1, simdiki[j - 1] + 1, onceki[j - 1] + maliyet);
          if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
            deger = Math.min(deger, onceki2[j - 2] + 1);
          }
          simdiki[j] = deger;
          if (deger < satirEnAz) satirEnAz = deger;
        }
        if (satirEnAz > ust) return ust + 1;
        onceki2 = onceki;
        onceki = simdiki;
      }
      return onceki[m];
    }

    function mailAlani(mail) {
      var at = mail.lastIndexOf('@');
      return at < 0 ? '' : mail.slice(at + 1).toLowerCase();
    }

    /* Muhtemelen kastedilen alan adı; öneri yoksa null. */
    function alanOnerisi(mail) {
      var alan = mailAlani(mail);
      if (!alan) return null;
      if (POPULER_ALANLAR.indexOf(alan) >= 0 || BILINEN_ALANLAR.indexOf(alan) >= 0) return null;
      var i, p;
      for (i = 0; i < POPULER_ALANLAR.length; i++) {
        if (duzenlemeUzakligi(alan, POPULER_ALANLAR[i], 1) === 1) return POPULER_ALANLAR[i];
      }
      for (i = 0; i < POPULER_ALANLAR.length; i++) {
        p = POPULER_ALANLAR[i];
        if (alan.length > p.length && alan.indexOf(p) === 0) return p;
      }
      return null;
    }

    /* Öneri kutusu: e-posta hata satırının hemen altına BİR kez kurulur. */
    var oneriKutu = null;
    var oneriReddedilen = ''; /* "Hayır" denen adres — aynı adres için tekrar sorulmaz */
    function oneriKutusu() {
      if (oneriKutu) return oneriKutu;
      var hataEl = kok.querySelector('[data-mc-hata]');
      if (!hataEl || !hataEl.parentNode) return null;
      oneriKutu = document.createElement('div');
      oneriKutu.className = 'maiyko-cark__oneri';
      oneriKutu.hidden = true;
      oneriKutu.innerHTML =
        '<p class="maiyko-cark__oneri-metin" data-mc-oneri-metin></p>' +
        '<div class="maiyko-cark__oneri-btnler">' +
          '<button type="button" class="maiyko-cark__oneri-evet" data-mc-oneri-evet></button>' +
          '<button type="button" class="maiyko-cark__oneri-hayir" data-mc-oneri-hayir>Adresi düzelt</button>' +
        '</div>';
      hataEl.parentNode.insertBefore(oneriKutu, hataEl.nextSibling);
      return oneriKutu;
    }

    function oneriGizle() {
      if (oneriKutu) oneriKutu.hidden = true;
    }

    /* Soruyu gösterir. "Evet" alan adını düzeltip devam(duzeltilmis) çağırır;
       "Adresi düzelt" kutuyu kapatıp alanı odaklar (v13.1) — aynı adresle
       tekrar dokunulursa sormadan sunucuya gider, kapı oradadır (422 →
       mesaj + kutu yeniden). Metin textContent ile kurulur (girdi HTML olarak
       basılmaz). */
    function oneriSor(mail, oneri, devam) {
      var kutu = oneriKutusu();
      if (!kutu) { devam(mail); return; }
      var alan = mailAlani(mail);
      var duzeltilmis = mail.slice(0, mail.lastIndexOf('@') + 1) + oneri;
      var metin = kutu.querySelector('[data-mc-oneri-metin]');
      var evet = kutu.querySelector('[data-mc-oneri-evet]');
      var hayir = kutu.querySelector('[data-mc-oneri-hayir]');
      if (metin) {
        metin.textContent = '';
        var b1 = document.createElement('b'); b1.textContent = alan;
        var b2 = document.createElement('b'); b2.textContent = oneri;
        metin.appendChild(b1);
        metin.appendChild(document.createTextNode(' yerine '));
        metin.appendChild(b2);
        metin.appendChild(document.createTextNode(' mu?'));
      }
      if (evet) evet.textContent = 'Evet, ' + oneri + ' yap';
      var mailEl = kok.querySelector('[data-mc-mail]');
      var temizle = function () {
        kutu.hidden = true;
        if (evet) evet.removeEventListener('click', evetTik);
        if (hayir) hayir.removeEventListener('click', hayirTik);
      };
      var evetTik = function () {
        temizle();
        if (mailEl) mailEl.value = duzeltilmis;
        devam(duzeltilmis);
      };
      var hayirTik = function () {
        temizle();
        oneriReddedilen = mail;
        if (mailEl) { try { mailEl.focus(); } catch (e) { /* yoksay */ } }
      };
      if (evet) evet.addEventListener('click', evetTik);
      if (hayir) hayir.addEventListener('click', hayirTik);
      kutu.hidden = false;
    }

    /* Kod ekranı notu (v13): sunucu adresi listeye almadıysa (yazım hatası /
       alan adı yok) anneye söylenir — kod yine geçerli. Sahte kalıp
       (deneme123) için not YOK. */
    var notEl = null;
    function teslimNotu(kayit) {
      var sebep = kayit && kayit.aboneSebep;
      if (sebep !== 'yazim_hatasi' && sebep !== 'mx_yok') {
        if (notEl) notEl.hidden = true;
        return false;
      }
      if (!notEl) {
        var dayanak = kok.querySelector('[data-mc-hazir-not]');
        if (!dayanak || !dayanak.parentNode) return false;
        notEl = document.createElement('div');
        notEl.className = 'maiyko-cark__not';
        dayanak.parentNode.insertBefore(notEl, dayanak.nextSibling);
      }
      notEl.textContent = 'Not: ' + (kayit.alan || 'girdiğin adres') +
        ' adresine e-posta ulaşmıyor, kampanya e-postalarını alamayacaksın. Kodun yine geçerli.';
      notEl.hidden = false;
      return true;
    }

    /* Etiketler TEK kaynaktan üretilir: hem servise (gövdedeki `etiketler`)
       hem YEDEK YOLDAKİ native formun contact[tags] alanına aynı değerler
       gider. Sözleşme sınırı: en fazla 5 etiket, her biri ≤32 karakter. */
    function etiketDizisi(seg, oran) {
      var t = ['cark-popup'];
      if (seg) t.push(String(seg).slice(0, 32));
      t.push('cark-%' + oran);
      return t.slice(0, 5);
    }

    function segDegeri() {
      var segEl = kok.querySelector('[data-mc-segler] input:checked');
      return segEl ? segEl.value : '';
    }

    /* YEDEK YOLDA gönderimden hemen önce gizli alanlar senkron doldurulur;
       e-posta zaten formun kendi contact[email] alanında. */
    function formuDoldur(form, seg, oran) {
      var tagAlan = form.querySelector('[data-mc-form-tags]');
      var donusAlan = form.querySelector('[data-mc-form-donus]');
      if (tagAlan) tagAlan.value = etiketDizisi(seg, oran).join(',');
      if (donusAlan) donusAlan.value = window.location.pathname + window.location.search;
    }

    /* v11: `abonelik` verilirse gövdeye `eposta` + `etiketler` eklenir ve
       sunucu müşteriyi Shopify'da abone eder. Alanlar OPSİYONEL olduğu için
       eski sunucu da aynı yanıtı verir (fail-open sözleşme). */
    function kodUret(abonelik, cb) {
      if (!servis || typeof window.fetch !== 'function') { cb(null); return; }
      var govde = { kanal: 'web', yuzde: secilen.y, sure: secilen.s };
      if (/^gid:\/\/shopify\/Collection\/[0-9]+$/.test(koleksiyon)) govde.koleksiyon = koleksiyon;
      if (abonelik && abonelik.eposta) {
        govde.eposta = abonelik.eposta;
        if (abonelik.etiketler && abonelik.etiketler.length) govde.etiketler = abonelik.etiketler;
        /* v13.1: bu istemci 422'yi anlıyor → sunucu bozuk adrese kod ÜRETMESİN. */
        govde.kapi = true;
      }
      var bitti = false;
      var zaman = window.setTimeout(function () { if (!bitti) { bitti = true; cb(null); } }, 8000);
      window.fetch(servis + '/api/kupon/uret', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(govde)
      })
        .then(function (r) {
          /* v13.1: 422 EPOSTA_GECERSIZ servis arızası DEĞİL — gövde okunur, yedek yola düşülmez. */
          if (r.status === 422) {
            return r.json().then(function (h) { return { gecersiz: h || {} }; }, function () { return { gecersiz: {} }; });
          }
          return r.ok ? r.json() : null;
        })
        .then(function (v) {
          if (bitti) return;
          bitti = true;
          window.clearTimeout(zaman);
          if (v && v.gecersiz) {
            var g = v.gecersiz;
            cb({ gecersiz: true, mesaj: String(g.message || ''), sebep: String(g.aboneSebep || ''), oneri: String(g.oneri || ''), alan: String(g.alan || '') });
            return;
          }
          if (!v || !v.kod || !v.bitis) { cb(null); return; }
          var bitis = Date.parse(v.bitis);
          if (!isFinite(bitis) || bitis <= Date.now()) { cb(null); return; }
          /* `abone:false` HATA DEĞİL — kupon geçerli, kullanıcıya hiçbir
             şey gösterilmez; yalnız sessiz konsol uyarısı. */
          if (abonelik && abonelik.eposta && v.abone !== true && window.console) {
            try { window.console.warn('[maiyko-cark] kupon üretildi, sunucu tarafı abonelik yapılamadı (abone=false)'); } catch (e) { /* yoksay */ }
          }
          cb({
            kod: String(v.kod),
            bitis: bitis,
            yuzde: parseInt(v.yuzde, 10) || secilen.y,
            abone: v.abone === true,
            /* v13: sunucu adresi listeye almadıysa sebep (kod ekranı notu için). */
            aboneSebep: typeof v.aboneSebep === 'string' ? v.aboneSebep : '',
            alan: abonelik && abonelik.eposta ? mailAlani(abonelik.eposta) : ''
          });
        })
        .catch(function () {
          if (!bitti) { bitti = true; window.clearTimeout(zaman); cb(null); }
        });
    }

    /* Üretimi BİR KEZ başlatır (v10: tetikleyen tek şey mail gönderimi).
       İlk deneme geçici bir ağ hatasına takılırsa 1.2 sn sonra BİR kez daha
       denenir; yine olmazsa yedek kod devreye girer. (Brave/adblock gibi
       cross-site istekleri kesen tarayıcılarda iki deneme de düşer — kalıcı
       çözüm servis için maiyko.com altı bir alan adı.) */
    var uretimBasladi = false;
    function kodHazirla(abonelik, bitince) {
      if (uretimBasladi) return;
      uretimBasladi = true;
      kodUret(abonelik, function (kayit) {
        /* v13.1: adres kapıya takıldı — kod YOK, yedek yol YOK; düzeltip yeniden denenebilsin. */
        if (kayit && kayit.gecersiz) { uretimBasladi = false; kodDurum = null; bitince(kayit); return; }
        if (kayit) { kodDurum = { kayit: kayit }; bitince(); return; }
        window.setTimeout(function () {
          kodUret(abonelik, function (kayit2) {
            if (kayit2 && kayit2.gecersiz) { uretimBasladi = false; kodDurum = null; bitince(kayit2); return; }
            kodDurum = kayit2 ? { kayit: kayit2 } : { hata: true };
            bitince();
          });
        }, 1200);
      });
    }

    /* Elde edilen kod kaydı: gerçek üretim başarısızsa YEDEK koda düşülür.
       Rozet/sayaç, çarkta çıkan oran DEĞİL yedek kodun GERÇEK yüzdesini
       gösterir (Maiyko10 = %10 iken %20 rozeti yanıltıcı olurdu). */
    function etkinKayit() {
      if (!kodDurum) return null;
      if (kodDurum.kayit) return kodDurum.kayit;
      if (yedekKod) return { kod: yedekKod, bitis: Date.now() + 30 * 60000, yuzde: yedekYuzde };
      return null;
    }

    /* Kod hazır: ortak durum yazılır, indirim ARKA PLANDA sepete işlenir ve
       formun return_to zinciri kurulur.

       İndirim ÇİFT kanaldan işlenir: (a) hemen arka planda /discount fetch'i
       (checkout cookie'si yazılır — bot koruması gönderimi yutup navigasyon
       gecikirse bile kupon ödemede hazır olur), (b) return_to zinciri (kayıt
       POST'u başarılıysa tarayıcı /discount üzerinden döner). İkisi de aynı
       cookie'yi yazar, çakışmaz. NOT: Shopify indirim kodları SEPETTE fiyat
       düşürmez, ÖDEME sayfasında otomatik uygulanır.

       redirect HEDEFİ ziyaretçinin BULUNDUĞU sayfadır (v10; eskiden sabit
       "/" idi): ürün sayfasında çarkı çeviren ürün sayfasına döner. Bilette
       bu zaten böyleydi, desen oradan alındı. */
    function kaydiKur(kayit, durum) {
      yaz(DYN_KEY, {
        kod: kayit.kod,
        bitis: kayit.bitis,
        durum: durum,
        yuzde: kayit.yuzde,
        dongu: 0,
        kampanya: 'cark',
        stil: 'altin',
        konum: 'left',
        alt: 180
      });
      var zincir =
        '/discount/' + encodeURIComponent(kayit.kod) +
        '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
      try {
        window.fetch(zincir, { credentials: 'same-origin' }).catch(function () {});
      } catch (e) { /* yoksay */ }
      var donus = mcForm ? mcForm.querySelector('[data-mc-form-donus]') : null;
      if (donus) donus.value = zincir;
    }

    /* Kayıt akışı ESKİ POPUP'LA BİREBİR: e-posta alanı ve 'İNDİRİMİ AL'
       butonu görünür müşteri formunun kendi içinde; gönderim kullanıcının
       KENDİ tıklamasının (veya Enter'ının) native submit'i. Shopify'ın bot
       koruması programatik gönderimleri ve form-dışı butonların submit'ini
       sessizce engelliyor — yalnız bu desen kayıt oluşturuyor (canlıda
       adım adım doğrulandı). Bu handler submit'in default action'ından
       önce koşar: geçersiz durumlarda preventDefault eder, geçerli durumda
       alanları SENKRON doldurup gönderimi serbest bırakır.

       v10 — İKİ DOKUNUŞ: kod artık çark dönerken DEĞİL, burada üretilir.
       Üretim async olduğu için 1. dokunuş gönderimi durdurur ("HAZIRLANIYOR…"),
       kod gelince durum/return_to/arka plan indirimi KURULUR ve buton
       "%X KODUN HAZIR ➜" olur; 2. dokunuş gerçek gönderimi yapar. Programatik
       gönderim İŞE YARAMADIĞI için ikinci dokunuş kullanıcının kendi
       hareketi olmak zorunda — bu desen zaten "bot koruması ilk submit'i
       yutuyor" durumu için vardı, şimdi tek yol o. Kod 1. dokunuşta
       kaydedildiğinden ziyaretçi orada bıraksa bile kodu kaybolmaz: site
       geneli koçan (maiyko-kupon-global.js) 'active' kaydı kurtarır. */
    /* Editörde buton type=button basılır (form post iframe'i resetliyordu)
       — gerçek akışın TAM simülasyonu: 'Kodun hazır' ekranı 3 sn kalır,
       popup kapanır ve sol altta ÖRNEK süre sayacı belirir. Editörde
       gerçek kod/sayaç KASITLI kurulmaz (her editör açılışı kota yakardı);
       gerçekte sayaç ve sepet indirimi canlı akışta çalışır. */
    function editorBitir() {
      asama(3);
      window.setTimeout(function () {
        gizle();
        /* Bilet minisiyle aynı dil: sol kenarda çıkıntı, tıklayınca
           yana açılan bilgi paneli. */
        var demo = document.createElement('div');
        demo.className = 'maiyko-cark-demomini';
        var oran = secilen ? secilen.y : dilimler[1].y;
        var sure = (secilen ? secilen.s : dilimler[1].s) * 60;
        demo.innerHTML =
          '<button type="button" class="maiyko-cark-demomini__cikinti" aria-expanded="false">' +
            '<b>%' + oran + '</b>' +
            '<span class="maiyko-cark-demomini__sag"><span data-demo-sayac></span><small>HEDİYEN</small></span>' +
          '</button>' +
          '<div class="maiyko-cark-demomini__panel" hidden>' +
            '<strong>Hoş geldin hediyen 🎁</strong>' +
            '%' + oran + ' indirim kodun aktif — süre bitmeden siparişini tamamla, ödemede otomatik uygulanır.' +
            '<i>ÖRNEK GÖSTERİM</i>' +
          '</div>';
        document.body.appendChild(demo);
        var cikinti = demo.querySelector('.maiyko-cark-demomini__cikinti');
        var panel = demo.querySelector('.maiyko-cark-demomini__panel');
        cikinti.addEventListener('click', function () {
          panel.hidden = !panel.hidden;
          cikinti.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
        });
        var sEl = demo.querySelector('[data-demo-sayac]');
        var tik = function () {
          sure -= 1;
          var m = Math.floor(sure / 60);
          var sn = sure % 60;
          sEl.textContent = (m < 10 ? '0' : '') + m + ':' + (sn < 10 ? '0' : '') + sn;
        };
        tik();
        window.setInterval(tik, 1000);
      }, 3000);
    }

    if (design) {
      var alBtnEd = kok.querySelector('[data-mc-al]');
      if (alBtnEd) alBtnEd.addEventListener('click', function () {
        var mailEd = kok.querySelector('[data-mc-mail]');
        var hataEd = kok.querySelector('[data-mc-hata]');
        if (!mailGecerli(mailEd ? mailEd.value.replace(/^\s+|\s+$/g, '') : '')) {
          if (hataEd) hataEd.hidden = false;
          return;
        }
        if (hataEd) hataEd.hidden = true;
        /* v13: editörde de aynı soru (gerçek kod üretilmez). */
        var mailEdDeger = mailEd ? mailEd.value.replace(/^\s+|\s+$/g, '') : '';
        var oneriEd = alanOnerisi(mailEdDeger);
        if (oneriEd && oneriReddedilen !== mailEdDeger) { oneriSor(mailEdDeger, oneriEd, function () { editorBitir(); }); return; }
        oneriGizle();
        editorBitir();
      });
    }

    var mcForm = document.getElementById('MaiykoCarkForm');
    /* v13.1: kapı hatasından sonra düğme bu metne döner. */
    var alBtnIlk = mcForm ? mcForm.querySelector('[data-mc-al]') : null;
    var alMetinOrijinal = alBtnIlk ? alBtnIlk.textContent : 'İNDİRİMİMİ AL';

    /* v11 — KOD EKRANI: sayfa DEĞİŞMEDEN aşama 3 açılır, oran yanıttaki
       GERÇEK yüzdeden basılır ve popup birkaç saniye sonra kendiliğinden
       kapanır (site geneli koçan zaten kurulmuştur). */
    function kodEkrani(kayit) {
      var o2 = kok.querySelector('[data-mc-oran2]');
      if (o2) o2.textContent = '%' + (kayit && kayit.yuzde ? kayit.yuzde : secilen.y) + ' indirim';
      /* v13: teslim notu varsa ekran okunabilsin diye daha uzun kalır. */
      var notVar = teslimNotu(kayit);
      asama(3);
      window.setTimeout(function () { gizle(); }, notVar ? 7000 : 3600);
    }

    /* v11 — TEK DOKUNUŞ: servise `eposta` + `etiketler` ile TEK istek gider.
       Başarılıysa abonelik de kupon da bitmiştir: kayıt 'copied' yazılır,
       {d:'mail'} bayrağı ANCAK BURADA basılır, koçan aynı sayfada kurulur ve
       kod ekranı açılır — native gönderim YAPILMAZ, sayfa değişmez.

       YEDEK YOL (v10 davranışı, KORUNDU): servis düşerse yedek koda düşülür,
       kayıt 'active' yazılır ve buton "%X KODUN HAZIR ➜" olur; ziyaretçinin
       İKİNCİ dokunuşu native müşteri formunu gönderir (bot koruması
       /challenge turunu yapar, return_to ile geri döner). */
    /* v13.1: sunucu adresi kapıda durdurdu — kod yok. Düğme eski hâline döner,
       mesaj hata satırında; öneri varsa kutu da açılır (Evet → düzeltip devam). */
    function kapiHatasi(mail, g) {
      var b = mcForm ? mcForm.querySelector('[data-mc-al]') : null;
      if (b) {
        b.classList.remove('is-bekliyor');
        b.classList.remove('is-hazir');
        b.textContent = alMetinOrijinal;
      }
      hataGoster(g.mesaj || hataMetinVarsayilan);
      if (g.oneri) oneriSor(mail, g.oneri, tekDokunus);
      var mailEl = kok.querySelector('[data-mc-mail]');
      if (mailEl && !g.oneri) { try { mailEl.focus(); } catch (e) { /* yoksay */ } }
    }

    function tekDokunus(mail) {
      if (istekYolda) return;
      istekYolda = true;
      var etiketler = etiketDizisi(segDegeri(), secilen.y);
      var bekleBtn = mcForm ? mcForm.querySelector('[data-mc-al]') : null;
      if (bekleBtn) {
        bekleBtn.textContent = 'Kodun hazırlanıyor…';
        bekleBtn.classList.remove('is-hazir');
        bekleBtn.classList.add('is-bekliyor');
      }
      kodHazirla({ eposta: mail, etiketler: etiketler }, function (gecersiz) {
        istekYolda = false;
        if (gecersiz && gecersiz.gecersiz) { kapiHatasi(mail, gecersiz); return; }
        var hazir = etkinKayit();

        /* SERVİS YOLU: gerçek kod geldi -> abonelik sunucuda yapıldı. */
        if (kodDurum && kodDurum.kayit && hazir) {
          kaydiKur(hazir, 'copied');
          mailKaydedildi = true;
          yaz(STATE_KEY, { d: 'mail', t: Date.now() });
          balonuKaldir();
          /* Koçan AYNI sayfada belirsin (sayfa yenilenmiyor). */
          try {
            if (typeof window.MaiykoMiniGlobalKur === 'function') window.MaiykoMiniGlobalKur();
          } catch (e) { /* yoksay */ }
          kodEkrani(hazir);
          return;
        }

        /* YEDEK YOL: 'active' -> ziyaretçi kodu henüz almadı; burada
           bırakırsa site geneli koçan "KODUN HAZIR — DOKUN" ile kurtarır. */
        if (hazir) kaydiKur(hazir, 'active');
        var b = mcForm ? mcForm.querySelector('[data-mc-al]') : null;
        if (!b) return;
        b.classList.remove('is-bekliyor');
        b.classList.add('is-hazir');
        b.textContent = hazir && hazir.yuzde
          ? '%' + hazir.yuzde + ' KODUN HAZIR ➜'
          : 'DEVAM İÇİN DOKUN ➜';
      });
    }

    /* DOKUNUŞ KAPISI — SUBMIT'TEN ÖNCE (canlıda ölçülen ders):
       Shopify'ın bot koruması submit dinleyicisini SAYFA YÜKLENİRKEN, yani
       bizim dinleyicimizden ÖNCE bağlıyor. Submit içindeki preventDefault
       onu durduramıyor — dokunuşta ziyaretçi kod daha üretilmeden
       /challenge'a gidiyordu. Çözüm: kod hazır değilken TIKLAMANIN KENDİSİ
       engellenir; submit olayı hiç doğmaz, bot koruması da devreye girmez.

       v11: SERVİS YOLUNDA bu kapı hiç açılmaz — kod geldiğinde de native
       gönderim yapılmaz (mailKaydedildi true). Kapı yalnız YEDEK YOLDA
       (kodDurum.hata) kenara çekilir ve ikinci dokunuş Shopify'a devrolur. */
    var alKapi = mcForm ? mcForm.querySelector('[data-mc-al]') : null;
    if (alKapi && !design) alKapi.addEventListener('click', function (e) {
      /* Yedek yolda kod hazır -> native submit serbest. */
      if (kodDurum !== null && !mailKaydedildi) return;
      e.preventDefault();
      if (mailKaydedildi) return; /* iş bitti, ikinci dokunuş yok */
      var mailEl = kok.querySelector('[data-mc-mail]');
      var hataEl = kok.querySelector('[data-mc-hata]');
      var mail = mailEl ? mailEl.value.replace(/^\s+|\s+$/g, '') : '';
      if (!mailGecerli(mail)) {
        hataGoster(hataMetinVarsayilan);
        return;
      }
      if (hataEl) hataEl.hidden = true;
      if (!secilen) secilen = dilimler[1];
      /* v13: yazım hatası şüphesinde önce sor; "Hayır" denmişse tekrar sorma. */
      var oneri = alanOnerisi(mail);
      if (oneri && oneriReddedilen !== mail) { oneriSor(mail, oneri, tekDokunus); return; }
      oneriGizle();
      tekDokunus(mail);
    });

    if (mcForm) mcForm.addEventListener('submit', function (e) {
      var mailEl = kok.querySelector('[data-mc-mail]');
      var hataEl = kok.querySelector('[data-mc-hata]');
      var mail = mailEl ? mailEl.value.replace(/^\s+|\s+$/g, '') : '';
      if (!mailGecerli(mail)) {
        e.preventDefault();
        hataGoster(hataMetinVarsayilan);
        return;
      }
      if (hataEl) hataEl.hidden = true;
      if (!secilen) secilen = dilimler[1];

      if (design) { e.preventDefault(); editorBitir(); return; }

      /* v11: servis yolu tamamlandı -> native gönderim ASLA yapılmaz. */
      if (mailKaydedildi) {
        e.preventDefault();
        if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        return;
      }

      if (kodDurum === null) {
        /* Buraya normalde GELİNMEZ: dokunuş yukarıdaki click kapısında
           kesilir. Enter ile gönderimde yedek yol olarak durur. */
        e.preventDefault();
        if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        var oneriS = alanOnerisi(mail);
        if (oneriS && oneriReddedilen !== mail) { oneriSor(mail, oneriS, tekDokunus); return; }
        oneriGizle();
        tekDokunus(mail);
        return;
      }

      /* YEDEK YOL 2. DOKUNUŞ — eski native gönderim (v10 davranışı). */
      formuDoldur(mcForm, segDegeri(), secilen.y);

      var kayit = etkinKayit();
      if (kayit) {
        /* Biletlerle ORTAK durum: 'copied' -> site geneli mini sayaç;
           kampanya 'cark' -> biletler tek-aktif-kupon ilkesiyle gizlenir.
           formuDoldur return_to'yu düz sayfa yoluna çevirdiği için zincir
           BURADAN sonra yeniden kurulur. */
        kaydiKur(kayit, 'copied');
      }
      yaz(STATE_KEY, { d: 'mail', t: Date.now() });
      /* preventDefault YOK: native submit sayfayı kayıt POST'una götürür.
         Shopify'ın bot koruması İLK submit'i bazen sessizce yutuyor
         (canlıda gözlendi: ikinci tıklama her zaman geçiyor). Programatik
         tekrar İŞE YARAMADIĞINDAN kullanıcı ikinci dokunuşa yönlendirilir;
         kupon durumu bu noktada zaten yazılmış olduğundan hiçbir şey
         kaybolmaz.

         DONMA HİSSİ YUMUŞATMASI (Yusuf isteği): dokunur dokunmaz buton
         "GÖNDERİLİYOR…" olur (nabız animasyonlu); gönderim yutulup sayfa
         hâlâ buradaysa 1.2 sn sonra KOD BİLGİLİ metinle ikinci dokunuşa
         çağrılır ("%X KODUN HAZIR ➜"). Buton disabled YAPILMAZ — ikinci
         gönderim de kullanıcının kendi dokunuşu olmak zorunda. */
      var alBtn = mcForm.querySelector('[data-mc-al]');
      if (alBtn) {
        alBtn.textContent = 'GÖNDERİLİYOR…';
        alBtn.classList.remove('is-hazir');
        alBtn.classList.add('is-bekliyor');
      }
      window.setTimeout(function () {
        var b = mcForm.querySelector('[data-mc-al]');
        if (!b) return;
        b.classList.remove('is-bekliyor');
        b.classList.add('is-hazir');
        b.textContent = kayit && kayit.yuzde
          ? '%' + kayit.yuzde + ' KODUN HAZIR ➜'
          : 'DEVAM İÇİN DOKUN ➜';
      }, 1200);
    });
  }

  function hepsiniKur() {
    document.querySelectorAll('[data-maiyko-cark]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hepsiniKur);
  } else {
    hepsiniKur();
  }
  document.addEventListener('shopify:section:load', hepsiniKur);
})();
